import React, { useContext, useState } from "react";

import { parseDateString } from "../dates";

import "./lotCodeManager.scss";
import LotCodeModalOpener from "./lotCodeModalOpener";
import { MODAL_MODE } from "./lotCodeModalView";
import { USER_ROLE, CanEdit } from "../signin/RoleContext";
import RestUtilities from "../services/Base";
import LPContext from "../lpLoader/LPContext";
import saveAs from "file-saver";

interface Props {
  lotCode: any;
  userRole: USER_ROLE;
}

const LotCodeListItem = (props: Props) => {
  const lpContext = useContext(LPContext);
  const [currentLpId, setCurrentLpId] = useState(lpContext.LP.id);

  const getCoa = async () => {
    const downloadLink = `/api/lot/${currentLpId}/${props.lotCode.harvestDate}/${props.lotCode.lotCodeId.trim()}/${props.lotCode.sku.trim()}/coa`;
    const response = await RestUtilities.get(downloadLink);
    saveAs(response.content, props.lotCode.qlCat.trim());
  }

  return (
    <div className="table-row">
      <div>{props.lotCode.sku}</div>
      <div>{props.lotCode.lotCodeId}</div>
      <div>{parseDateString(props.lotCode.harvestDate)}</div>
      <div className="value">
        <span style={{color:props.lotCode.thcOutOfRange ? "inherit" : "red"} }>{props.lotCode.thc}</span> {props.lotCode.thcUnits}
      </div>
      <div className="value">
        <span style={{ color: props.lotCode.cbdOutOfRange ? "inherit" : "red" }}>{props.lotCode.cbd}</span> {props.lotCode.cbdUnits}
      </div>
      <div>{props.lotCode.qlCoa?.trim() ? <button className={'btn btn-orange'} onClick={getCoa}>View</button> : ''}</div>
      <div>
        {CanEdit(props.userRole) && (
          <LotCodeModalOpener
            type={MODAL_MODE.EDIT}
            lotCode={props.lotCode}
            disabled={props.lotCode.statusFlag.trim() === "Y"}
          >
            Edit
          </LotCodeModalOpener>
        )}
      </div>
    </div>
  );
};

export default LotCodeListItem;
